<div class="bg-white w-full max-w-[500px] p-6 relative">
    <div>
      <!-- Botón cerrar (solo en desktop) -->
      <button type="button" class="close-button hidden md:block" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>

      <!-- Título -->
      <h2 class="headline-07 text-2xl font-bold text-[#134F82] mb-2">
        Recupera<br />tu contraseña
      </h2>

      <!-- Subtítulo -->
      <div class="mb-4">
        <p class="font-semibold text-[#134F82] headline-06 pt-2">Ingresa tu correo</p>
        <p class="text-sm text-gray-600 paragraph-default">
          Enviaremos un código de verificación a tu correo electrónico para restablecer tu
          contraseña.
        </p>
      </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-4">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Correo electrónico</mat-label>
        <input matInput formControlName="email" type="email" />
        <mat-error *ngIf="form.get('email')?.hasError('required')">Campo requerido</mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('email')">Correo inválido</mat-error>
      </mat-form-field>

      <p *ngIf="correoIncorrecto" class="text-[#BA1A1A] mx-1 pb-3">
        El correo no se encuentra registrado.
    </p>


      <button color="primary" class="w-full rounded-full bg-[#0E365A] text-white py-3 hover:bg-[#0c2f4e]" type="submit"
        [disabled]="form.invalid">
        Continuar
      </button>
    </form>
</div>
